// The resource behind a local address, read once for an upload. Shared by the
// legacy upload batch (`common/hooks/useRequestsBatch`) and the ports.

export const fetchResourceFromURI = async (uri) => {
    const response = await fetch(uri)
    return await response.blob()
}

// On the web a picked or captured file is an address (`blob:` from a picker,
// `data:` from the camera); a multipart upload needs the File behind it.
export const fileFromURI = async (uri, name, fallbackType) => {
    const blob = await fetchResourceFromURI(uri)
    return new File([blob], name, { type: blob.type || fallbackType })
}
